var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMiniColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 50,
    viewBox: "0 0 34 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59712 29.2583L15.7207 24.6188L15.7502 8.38248L2.36804 0.680573V32.2391L7.59712 29.2583Z",
    fill: "#FF5227"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3874 22.5915L17.3841 24.6255L30.6025 32.3307L30.6058 16.9366L17.4136 9.34247L17.3874 22.5915Z",
    fill: "#FFFF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52048 30.6427L2.36804 34.1557V49.6412L29.8559 33.8162L16.5458 26.0588L8.52048 30.6427Z",
    fill: "#1B229F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMiniColor);
export default __webpack_public_path__ + "static/media/logo-mini-color.e070e9bd48a562ee30a2d9bca1730a6b.svg";
export { ForwardRef as ReactComponent };